import axios from "axios";
import { API_BASE } from "@/lib/api";

const KEY = "portal.token";

export const portalToken = {
  get: () => localStorage.getItem(KEY),
  set: (t) => localStorage.setItem(KEY, t),
  clear: () => localStorage.removeItem(KEY),
};

/** Client portal API: separate token from staff auth, never refreshed. */
export const portalApi = axios.create({ baseURL: `${API_BASE}/portal` });

portalApi.interceptors.request.use((config) => {
  const t = portalToken.get();
  if (t) config.headers.Authorization = "Bearer " + t;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && !String(error.config?.url).endsWith("/login")) {
      portalToken.clear();
      window.dispatchEvent(new Event("portal-logout"));
    }
    return Promise.reject(error);
  }
);
